import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-[#05070d]">
      {/* Background glow orbs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] rounded-full bg-cyan-500/8 blur-[120px]" />
        <div className="absolute top-1/3 right-1/4 w-[400px] h-[400px] rounded-full bg-violet-600/10 blur-[100px]" />
        <div className="absolute bottom-1/4 left-1/2 w-[300px] h-[300px] rounded-full bg-blue-600/8 blur-[80px]" />
        {/* Grid overlay */}
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 pt-28 md:pt-36 pb-16 flex flex-col items-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/25 text-cyan-400 text-xs font-semibold mb-8 backdrop-blur-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse inline-block" />
          Dünya Genelinde 2M+ Aktif Kullanıcı
        </div>

        {/* Main Headline */}
        <h1 className="text-center text-4xl sm:text-5xl md:text-7xl font-extrabold text-white leading-tight tracking-tight mb-6 max-w-4xl">
          Tek Tıkla{' '}
          <span className="relative inline-block">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-violet-500">
              Görüntülü
            </span>
          </span>{' '}
          Sohbete Başla
        </h1>

        {/* Subheadline */}
        <p className="text-center text-white/50 text-base md:text-xl max-w-2xl mb-10 leading-relaxed">
          Anında eşleş, yeni insanlarla tanış, tek dokunuşla devam et. Dünyanın dört bir yanından insanlarla güvenli ve premium deneyim.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-4 mb-16">
          <Link
            to="/auth"
            className="group relative inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white font-bold text-base hover:from-cyan-400 hover:to-violet-500 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-cyan-500/25 hover:shadow-cyan-500/40 hover:scale-105"
          >
            <i className="ri-video-on-line text-lg" />
            Hemen Başla
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </Link>
          <a
            href="#how-it-works"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white/5 border border-white/10 text-white/80 font-medium text-base hover:bg-white/10 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-play-circle-line text-lg" />
            Nasıl Çalışır?
          </a>
        </div>

        {/* Fake Video Chat Preview */}
        <div className="relative w-full max-w-4xl">
          {/* Glow border */}
          <div className="absolute -inset-1 rounded-3xl bg-gradient-to-r from-cyan-500/30 via-violet-600/20 to-cyan-500/30 blur-lg" />
          <div className="relative bg-[#0d1117]/90 backdrop-blur-xl rounded-3xl border border-white/10 overflow-hidden">
            {/* Top bar */}
            <div className="flex items-center justify-between px-5 py-3 border-b border-white/5 bg-white/2">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-red-500/80" />
                <div className="w-3 h-3 rounded-full bg-yellow-500/80" />
                <div className="w-3 h-3 rounded-full bg-emerald-500/80" />
              </div>
              <div className="flex items-center gap-2 text-white/30 text-xs">
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse inline-block" />
                Bağlı · Türkiye ↔ Japonya
              </div>
              <div className="flex items-center gap-3">
                <span className="text-white/20 text-xs">🔒 Şifreli</span>
              </div>
            </div>

            {/* Video area */}
            <div className="relative grid grid-cols-2 gap-0 h-[260px] md:h-[380px]">
              {/* Remote video */}
              <div className="relative overflow-hidden border-r border-white/5">
                <img
                  src="https://readdy.ai/api/search-image?query=young%20woman%20smiling%20looking%20at%20camera%2C%20soft%20studio%20lighting%2C%20blurred%20face%20privacy%2C%20dark%20background%20with%20neon%20blue%20glow%2C%20modern%20aesthetic%2C%20cinematic%20portrait%20photography&width=600&height=400&seq=hero1&orientation=landscape"
                  alt="Karşı Kullanıcı"
                  className="w-full h-full object-cover object-top"
                  style={{ filter: 'blur(6px) brightness(0.7)' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                {/* User badge */}
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-black/60 backdrop-blur-sm border border-white/10 text-white/80 text-xs">
                    <span>🇯🇵</span>
                    <span>Tokyo, JP</span>
                  </div>
                </div>
                {/* Connection quality */}
                <div className="absolute top-3 right-3">
                  <div className="flex items-end gap-0.5">
                    {[3, 5, 7, 9].map((h, i) => (
                      <div key={i} className="w-1 rounded-sm bg-emerald-400" style={{ height: `${h}px` }} />
                    ))}
                  </div>
                </div>
              </div>

              {/* Self preview */}
              <div className="relative overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=young%20man%20relaxed%20at%20home%2C%20laptop%20glow%20lighting%2C%20blurred%20face%20privacy%2C%20dark%20room%20with%20monitor%20neon%20lighting%2C%20casual%20modern%20style%2C%20cinematic%20portrait&width=600&height=400&seq=hero2&orientation=landscape"
                  alt="Siz"
                  className="w-full h-full object-cover object-top"
                  style={{ filter: 'blur(5px) brightness(0.65)' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5 px-3 py-1 rounded-full bg-black/60 backdrop-blur-sm border border-white/10 text-white/80 text-xs">
                  <span>🇹🇷</span>
                  <span>Sen</span>
                </div>
              </div>

              {/* Center overlay text */}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="flex flex-col items-center gap-2">
                  <div className="w-12 h-12 rounded-full bg-cyan-500/20 backdrop-blur-sm border border-cyan-500/40 flex items-center justify-center">
                    <i className="ri-video-on-line text-cyan-400 text-xl" />
                  </div>
                  <span className="text-white/60 text-xs bg-black/40 px-3 py-1 rounded-full backdrop-blur-sm">Canlı bağlantı</span>
                </div>
              </div>
            </div>

            {/* Control bar */}
            <div className="flex items-center justify-center gap-3 px-5 py-4 bg-black/40 border-t border-white/5">
              {[
                { icon: 'ri-mic-line', label: 'Mikrofon', active: true },
                { icon: 'ri-camera-line', label: 'Kamera', active: true },
                { icon: 'ri-chat-3-line', label: 'Sohbet', active: false },
              ].map((btn) => (
                <button
                  key={btn.label}
                  className={`w-10 h-10 flex items-center justify-center rounded-full border transition-all cursor-pointer ${
                    btn.active
                      ? 'bg-white/8 border-white/15 text-white/70 hover:bg-white/15'
                      : 'bg-white/5 border-white/10 text-white/40'
                  }`}
                >
                  <i className={`${btn.icon} text-base`} />
                </button>
              ))}
              <button className="px-6 py-2.5 rounded-full bg-gradient-to-r from-cyan-500 to-violet-600 text-white text-sm font-bold whitespace-nowrap cursor-pointer hover:from-cyan-400 hover:to-violet-500 transition-all shadow-lg shadow-cyan-500/20">
                Sonraki →
              </button>
              <button className="w-10 h-10 flex items-center justify-center rounded-full bg-red-500/15 border border-red-500/25 text-red-400 hover:bg-red-500/25 transition-all cursor-pointer">
                <i className="ri-stop-circle-line text-base" />
              </button>
            </div>
          </div>
        </div>

        {/* Stats row */}
        <div className="flex flex-wrap items-center justify-center gap-8 mt-12">
          {[
            { num: '2M+', label: 'Aktif Kullanıcı' },
            { num: '180+', label: 'Ülke' },
            { num: '50M+', label: 'Sohbet' },
            { num: '4.9★', label: 'Kullanıcı Puanı' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-violet-400">
                {stat.num}
              </div>
              <div className="text-white/35 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
